import { LmiContractConfig, QualificationType } from './types';

export const mnLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit and if you participate in a qualifying low-to-moderate income (LMI) program.',
  lmiProofCategory: 'proof_docs',
  requiresDocumentUpload: true,
  contractTag: 'mn_lmi',

  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: true,
      placeholder: 'Select your county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualificationType',
      type: 'checkbox',
      label: 'Please review and check the statement below to continue.',
      required: true,
      options: [
        {
          value: QualificationType.MN_COMBINED,
          label:
            "I confirm that at least one permanent member of my household participated in {programName} within the past three years, and my household's total annual income is below {incomeLimit}.",
          enableWhen: {
            allOf: ['county', 'householdOccupancy', 'qualifyingProgram'],
          },
          interpolations: {
            programName: {
              source: 'field',
              fieldName: 'qualifyingProgram',
            },
            incomeLimit: {
              source: 'variable',
              variableName: 'incomeLimit',
            },
          },
        },
      ],
    },
  ],

  contractLink: {
    preText: 'I have reviewed the',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
